import { translate } from '../../intl/i18n'
import { MobileMenu } from '../MobileMenu/MobileMenu'
import { MobileMenuContent } from '../MobileMenu/components/MobileMenuContent.styled'
import { useAppDispatch, useAppSelector } from '../../hooks'
import { useMobileMenuCloseOnExternalAction } from '../MobileMenu/hooks/useMobileMenuCloseOnExternalAction'
import { clearModal } from '../../store/actions/modalActions/clearModal'
import { selectAddress } from '../../store/selectors/user.selectors'
import { useEffect, useState } from 'react'
import { MobileMenuSectionConnectedEvmWallet } from '../MobileMenu/components/MobileMenuSectionConnectedEvmWallet'

export const MobileMenuConnectedWallets = () => {
  const userAddress = useAppSelector(selectAddress)
  const dispatch = useAppDispatch()

  const [menuOpen, setMenuOpen] = useState(true)

  const closeMenu = useMobileMenuCloseOnExternalAction({
    close: () => {
      setMenuOpen(false)
    },
    externalAction: () => {
      clearModal(dispatch)()
    },
  })

  useEffect(() => {
    if (!userAddress) {
      closeMenu()
    }
  }, [userAddress, dispatch, closeMenu])

  return (
    <MobileMenu show={menuOpen} headerText={translate('onboarding.connect_wallet')} handleClose={closeMenu}>
      <MobileMenuContent>
        <MobileMenuSectionConnectedEvmWallet showBorder={false} />
      </MobileMenuContent>
    </MobileMenu>
  )
}
